<template>
<div>
    <smallbutton @click="Start()" :toplabel="RoleTitle" :class="buttonclass"/>
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <div class="lookupdetail2">
                <div class="lookup">
                    <div class="lookupHeader">
                        <label class="titlelabel bottom10">{{ RoleTitle }}</label>
                            
                    </div>
                    <div class="horizFlex ">
                        <input id="showinactivecheck" class="entryCheckbox" type="checkbox" v-model="showInactive" @change="getRoles">
                        <label for="showinactivecheck" class="mediumtext">Show Inactive</label>
                    </div>
                    <div class="leftjustified">
                        <updatepersonrole @refresh="getRoles" :isAdd="trueParam" buttonclass="innerbutton" @refreshnew="getRoles" :isEmployee="isEmployee" :isStudent="isStudent"/>
                    </div>
                    
                    <div class="resultsdiv" v-if="personRoleList.length>0" tabindex="0">
                        <div v-for="result in personRoleList" :key="result.id" :value="result.id" >
                            <lookupresult :topLeft="result.name"   @click="select(result)"
                                :selected="result.id==selectedResultID_Role" :inactive="!result.isActive">
                            
                            </lookupresult>  
                        </div>
                    </div>
                </div>
        
                <div v-if="selectedResultID_Role>0" class="pad10">
                    <div class="bordered">
                        <div class="horizFlexStretch">
                            <div class="horizFlex">
                                <label class="titlelabel bold right10">{{currentPersonRole.name}} </label>
                                <updatepersonrole :inPersonRole="currentPersonRole"  @refresh="getRoles"  :isEmployee="isEmployee" :isStudent="isStudent"/>
                            </div>
                        <div></div>
                        </div>
                        <div class="splitDiv ">
                            <!-- left col -->
                            <div class="leftjustified vertFlex padright">
                                
                                
                                <div class="dataitem_role" >
                                    <p >Name:</p>
                                    <p >{{currentPersonRole.name}}</p>
                                </div>
                                <div class="dataitem_role" >
                                    <p >Is Active:</p>
                                    <p >{{currentPersonRole.isActive}}</p>
                                </div>
                                
                            </div>

                            <!-- right col -->
                            <div class="leftjustified vertFlex ">
           
                            </div>
                        </div>
                        
                    </div>

                </div>
                
            </div>
             <div v-if="pleaseWait">
                  <label class="pleasewait">Please Wait...</label>
              </div> 
            <div>
                <smallbutton  @click="Close()" toplabel="Close"/>
            </div>
            
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import datamethods from '../../services/datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import confirm from '../actions/confirm.vue'
import updatepersonrole from './updatepersonrole.vue'
import lookupresult from '../controls/lookupresult.vue'
export default {
    name:'roleadmin',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        confirm,
        updatepersonrole,
        lookupresult
    },
    props:{
        
        isStudent:{
            type:Boolean,
            default:false
        },
        isEmployee:{
            type:Boolean,
            default:true
        },
        buttonclass:{
                type:String,
                default:'updatebutton'
            },

    },
    mixins:[datamethods,format],
    data(){
        return{
            trueParam:true,
            personRoleList:[],
            selectedResultID_Role:0,
            currentPersonRole:{},
            showInactive:false,
            pleaseWait:false
            
        }
    },
    computed:{
        ...mapFields([
           'locationList',
           'loggedInUser'
        

        ]),
       RoleTitle(){
        if(this.isStudent){return 'Student Roles'}
        if(this.isEmployee){return 'Employee Roles'}
       }
    },
    methods:{
        
       Start(){
        this.getRoles()
        this.message=''
        this.$refs.mymodal.openModal()
       },
       Close(){
        this.$refs.mymodal.closeModal()
       },
        async save(){
            

            
            let req = {
                person:this.person,
                amount:this.productamount,
                sendSMS:this.sendNewSMS,
                removeOldJobRecords:!this.showLocationsEmployee || this.isStudent
            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'updateperson')
            if(response.Successful){
                //save prod sale


                this.$refs.mymodal.closeModal()
                //console.log(response)

                if(this.isAdd){
                    this.$emit('refreshnew',response.person.ID, response.walletId)
                }else{
                    this.$emit('refresh')
                }
                
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
       select(result){
              this.selectedResultID_Role=result.id
              this.currentPersonRole=result
          },
          
        async getRoles(){
            let req = {
                locationId:-1,
                employeeOnly:this.isEmployee,
                studentOnly:this.isStudent,
                limitToShowOnAdmin:true,
                limitToActive:!this.showInactive
            }
            //this.beforeAPI();
            this.pleaseWait=true
            var response = await this.callAPI(req,'rolelist')

            //handle response
            if(response.Successful){
            this.personRoleList = response.PersonRoleList
    
            if(this.personRoleList.length>0){
               //find student and pick it as default
              
                
                
            }
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        
    }
}
</script>

<style scoped>
.dataitem_role{
    display:grid;
    grid-template-columns: 160px auto;
    margin:0px;
    padding:0px;
}
.lookupdetail2{
     margin:0px;
    display:grid;
    grid-template-columns:1fr 2fr;
    grid-template-rows:auto;
    grid-template-areas: 
    "lookup detail"
}
</style>





























